import Diagram from '@semantical/modules/diagram/Diagram';
import { KnowledgeGraph } from '@semantical/modules/knowledge-graph';
import type { OntologyEnabledBoundedContext } from '@semantical/modules/workspace';

/**
 * Repository for serializing/deserializing Diagram objects.
 * Delegates to the Diagram class's toJSON/fromJSON methods.
 */
export class DiagramRepository {
    /**
     * Serialize a Diagram to a plain object suitable for storage.
     * Uses the Diagram's built-in toJSON() method.
     */
    serialize(diagram: Diagram): ReturnType<Diagram['toJSON']> {
        return diagram.toJSON();
    }

    /**
     * Deserialize a stored diagram, linking to the provided KnowledgeGraph.
     * Uses the Diagram's static fromJSON() method.
     * Returns null if deserialization fails.
     *
     * @param data - The serialized diagram data
     * @param knowledgeGraph - The KnowledgeGraph for resolving ABox individuals
     * @param boundedContext - Optional OntologyEnabledBoundedContext for resolving TBox individuals (SchemaIndividual)
     */
    deserialize(data: any, knowledgeGraph: KnowledgeGraph, boundedContext?: OntologyEnabledBoundedContext): Diagram | null {
        try {
            return Diagram.fromJSON(data, knowledgeGraph, boundedContext);
        } catch (error) {
            console.error('DiagramRepository.deserialize failed:', error);
            return null;
        }
    }
}
